import { getActiveFilter } from '../../../features/data-types'
import { O } from '../../../features/ui'
import { useStateHooks } from '../../../state'
import { TableName } from '../../../tables'
import { useLoaders } from '../../common'
import { useSystemStateHooks } from '../../system'
import { PaymentType } from '../state/types'

export const usePaymentTypeLoaders = () => {
    const systemHooks = useSystemStateHooks()
    const { getList, find } = useStateHooks()
    
    const loaders = useLoaders()

    return (companyId = systemHooks.companyId) => {
        const findAllPaymentTypes = (active = false) => getList(TableName.PAYMENT_TYPES, active) as PaymentType[]

        const findPaymentType = (id?: string) => find(TableName.PAYMENT_TYPES, id) as O<PaymentType>

        const loadAllPaymentTypes = async (active = false) => {
            const { loadMultiple } = loaders(companyId)
            const options = active ? getActiveFilter() : undefined
            const response = await loadMultiple(TableName.PAYMENT_TYPES, options)
            return response.dataTypes as PaymentType[]
        }

        const loadPaymentType = (
            id: string,
            dbRequest = false
        ) => {
            const { load } = loaders(companyId)
            return load(TableName.PAYMENT_TYPES, id, dbRequest) as Promise<O<PaymentType>>
        }

        return {
            findAllPaymentTypes,
            findPaymentType,
            loadAllPaymentTypes,
            loadPaymentType
        }
    }
}
